import React from "react";

export default function ElektroMannIcon({ className = "" }) {
  return (
    <svg
      viewBox="0 0 56 88"
      aria-hidden="true"
      className={className}
      focusable="false"
    >
      <g fill="none" strokeLinecap="round">
        <path d="M22,23 C20,16 15,10 10,4" stroke="#16a34a" strokeWidth="4" />
        <path d="M22,23 C20,16 15,10 10,4" stroke="#eab308" strokeWidth="1.4" strokeDasharray="2 4" opacity="0.75" />
        <path d="M28,22 L28,3" stroke="#38bdf8" strokeWidth="4" />
        <path d="M34,23 C36,16 41,10 46,4" stroke="#92400e" strokeWidth="4" />
      </g>

      <g>
        <ellipse cx="9.5" cy="3.5" rx="3.2" ry="2.4" fill="#f59e0b" transform="rotate(-22,9.5,3.5)" />
        <ellipse cx="28" cy="2.5" rx="3.2" ry="2.4" fill="#f59e0b" />
        <ellipse cx="46.5" cy="3.5" rx="3.2" ry="2.4" fill="#f59e0b" transform="rotate(22,46.5,3.5)" />
      </g>

      <rect x="15" y="22" width="26" height="64" rx="5" fill="#e2e8f0" stroke="rgba(255,255,255,0.22)" strokeWidth="0.6" />
      <rect x="17" y="22" width="7" height="64" rx="3" fill="rgba(255,255,255,0.45)" />
      <rect x="34" y="22" width="5" height="64" rx="2" fill="rgba(0,0,0,0.06)" />

      <path d="M15,52 C9,57 7,64 9,70" stroke="#cbd5e1" strokeWidth="2.2" strokeLinecap="round" fill="none" />
      <circle cx="9" cy="70" r="1.8" fill="#e2e8f0" />
      <path d="M41,52 C47,57 49,64 47,70" stroke="#cbd5e1" strokeWidth="2.2" strokeLinecap="round" fill="none" />
      <circle cx="47" cy="70" r="1.8" fill="#e2e8f0" />

      <ellipse cx="23" cy="40" rx="4.8" ry="5.2" fill="white" stroke="rgba(0,0,0,0.06)" strokeWidth="0.3" />
      <ellipse cx="33" cy="40" rx="4.8" ry="5.2" fill="white" stroke="rgba(0,0,0,0.06)" strokeWidth="0.3" />
      <circle cx="23" cy="40" r="2.8" fill="#1e293b" />
      <circle cx="33" cy="40" r="2.8" fill="#1e293b" />
      <circle cx="24.2" cy="38.1" r="1.1" fill="white" opacity="0.9" />
      <circle cx="34.2" cy="38.1" r="1.1" fill="white" opacity="0.9" />

      <path d="M24,50 Q28,54 32,50" fill="none" stroke="#475569" strokeWidth="1.5" strokeLinecap="round" />
      <circle cx="17" cy="46" r="3" fill="#fb923c" opacity="0.08" />
      <circle cx="39" cy="46" r="3" fill="#fb923c" opacity="0.08" />
    </svg>
  );
}
